import { ERROR_TYPES } from 'layers/content/constants'

export function createCurriculumNavigationStateKey(contentGroupCode, siteId) {
  return `${contentGroupCode}::${siteId}`
}

const selectCurriculumNavigation = (contentGroupCode, siteId) => state => {
  const navigationStateKey = createCurriculumNavigationStateKey(
    contentGroupCode,
    siteId,
  )
  const entry =
    state.curriculumNavigationManager?.navigation?.[navigationStateKey]

  return {
    data: entry?.data || null,
    error: entry?.error
      ? { message: entry.error, errorType: ERROR_TYPES.contentServiceError }
      : null,
    loading: entry?.isFetching === true,
  }
}

export default {
  selectCurriculumNavigation,
}
